import t from "react";
import { getWeekdayNames as s } from "./index66.mjs";
import a from "./index67.mjs";
const c = ({ locale: o = window.I18n.locale }) => {
  const r = s(o);
  return /* @__PURE__ */ t.createElement("div", { "data-testid": "week", className: a.week_container }, r.map((e) => /* @__PURE__ */ t.createElement(
    "div",
    {
      "data-testid": "weekday",
      className: a.week_day,
      key: e,
      translate: "no"
    },
    e
  )));
};
export {
  c as Week
};
